import { all } from 'redux-saga/effects';

import auth from './saga/auth/saga';
import user from './saga/user/saga';

export default function* rootSaga() {
    return yield all([ auth, user ]);
}